<script>
import {
    Block,
    BlockTitle,
    Link,
    Tabs,
    Tab
} from 'framework7-svelte';
$: refLink={ 
    link3_1:false,
    link3_2:false,
    link3_3:false,
    link3_4:false,
    link3_5:false,
    link3_6:false,
    link3_7:false
}
function changeLink(idLink){
    //refLink.find
    for (const property in refLink) {
        if(property===idLink){
            refLink[property]=true
        }else{
            refLink[property]=false
        }
        console.log(`${property}: ${refLink[property]}`);
    }
}
import { onMount } from 'svelte';
onMount(() => {

})
</script>
<style>
    table {
        border: none;
        width: 100%;
        border-collapse: collapse;
    }
    td {
        padding: 5px 10px;
        text-align: center;
        border: 1px solid #999;
    }
    th {
        padding: 5px 10px;
        text-align: center;
        border: 1px solid #999;
    }
</style>
<Block>
    <p>
        Información disponible
    </p>
</Block>
<Block strong inset>
    <ol>
        <li><p><Link on:click={()=>{
                        changeLink('link3_1')
                    }}>Puntos de calor</Link></p></li>
        <li><p><Link on:click={()=>{
                        changeLink('link3_2')
                    }}>Mapas de alerta</Link></p></li>
        <li><p><Link on:click={()=>{
                        changeLink('link3_3')
                    }} >Áreas quemadas y Emisiones</Link></p></li>
        <li><p><Link on:click={()=>{
                        changeLink('link3_4')
                    }} >Mapas resultados de análisis</Link></p></li>
        <li><p><Link on:click={()=>{
                        changeLink('link3_5')
                    }} >Mosaicos de imágenes satelitales MODIS, VIIRS y ABI-GOES</Link></p></li>
        <li><p><Link on:click={()=>{
                        changeLink('link3_6')
                    }} >Cartografía complementaria</Link></p></li>
        <li><p><Link on:click={()=>{
                        changeLink('link3_7')
                    }} >Tablas</Link></p></li>

    </ol>
</Block>
<Block>
    <p>
        El presente documento tiene la finalidad de enlistar los productos que se pueden consultar o bajar de la página web del Sistema de Alerta Temprana de Incendios Forestales (SATIF). Además de indicar como se debe citar la información.
    </p>
</Block>
<Tabs>
    <Tab id="tab-3-1" tabActive={refLink['link3_1']}>
        <BlockTitle >1. PUNTOS DE CALOR</BlockTitle>
        <Block strong mediumInset style="text-align: justify;">
            <p>La información disponible en la base de datos del SATIF sobre la detección y monitoreo del fuego activo a través de los puntos de calor se muestra en la tabla
            <br/>1. Cabe mencionar que los datos de 1998 y 1999 no se encuentra en la base de datos, porque fueron polígonos, sin embargo, es posibles consultarlos en esta misma página.
            </p>
            <p><strong>Consulta:</strong></p>
            <p><strong>A.</strong> Los puntos de calor detectados con imágenes MODIS y VIIRS se pueden consultar y desplegar en el mapa de la página web con las siguientes opciones:</p>
            <ol type="a">
                <li>Los puntos de calor del día actual en la pestaña de Temas. La información se despliega con dos colores: en rojo puntos detectados con imágenes nocturnas (entre las 7:00 p.m. y 6:59 a.m.), en color amarillo puntos de calor detectados con imágenes diurnas (entre las 7:00 a.m. a 6:59 p.m.). Este mapa se actualiza conforme se reciben las imágenes de satélite de la fecha correspondiente en el sistema de recepción de imágenes satelitales de la CONABIO. Asociado a este tema se pueden consultar los conglomerados de puntos de calor.</li>
                <li>Los puntos de calor a través de una consulta temporal hasta tres meses consecutivos, en la pestaña de Consultas. Los puntos de calor se despliegan clasificados conforme el número de día detectado hacia atrás, los puntos en color rojo más fuerte indican los más recientes. Esta opción permite ver la dirección de la propagación del fuego.</li>
                <li>Compuesto mensual de puntos de calor en la pestaña de Consultas. Los puntos de calor se despliegan clasificados por formación vegetal. Esta opción permite observar la evolución espacial del fuego en el país a lo largo del año.</li>
                <li>Los mapas de puntos de calor de 1998 y 1999 en la pestaña de Consultas. La información se despliega en forma de polígonos.</li>
            </ol>
            <p><strong>B.</strong>Los puntos de calor detectados con imágenes ABI-GOES (provenientes del Instituto de Geografía de la Universidad Nacional Autónoma de México (UNAM): http://www.lanot.unam.mx/).</p>
            <ol type="a">
                <li>Mapa de los últimos puntos de calor detectados se actualiza cada 10 mins. Resolución: 2 km. En la pestaña de Temas se encuentra como Puntos de calor GOES LANOT. </li>
                <li>Mapa del acumulado de puntos de calor de las últimas 24 horas, se muestra en heatmap y puntos. Resolución: 2 km. En la pestaña de Temas se encuentra como Puntos de calor GOES LANOT. </li>
                <!--<li>Mapa del acumulado de puntos de calor de una hora que se actualizan cada media hora. Resolución: 1 km. En la pestaña de Temas se encuentra como Puntos de calor GOES (última hora).</li>
                <li>Se muestran los puntos en un heatmap (elaborado por la CONABIO) que indica con colores las áreas con mayor concentración de puntos. En la pestaña de Temas se encuentra como Densidad de puntos de calor.</li>
                <li>Mapa que muestra conjuntos de puntos de calor (elaborado por la CONABIO) indicando la cantidad de puntos detectados. En la pestaña de Temas se encuentra como Clúster de puntos de calor 24 hr.</li> -->
            </ol>
            <p><strong>C.</strong>Los puntos de calor detectados con imágenes ABI-GOES (provenientes de NOAA: https://www.goes-r.gov/products/baseline-fire-hot-spot.html ).</p>
            <ol type="a">
                <li>Mapa de los últimos puntos de calor detectados se actualiza cada 10 mins. Resolución: 2 km. En la pestaña de Temas se encuentra como Puntos de calor GOES NOAA. </li>
                <li>Mapa del acumulado de puntos de calor de las últimas 24 horas, se muestra en heatmap y puntos. Resolución: 2 km. En la pestaña de Temas se encuentra como Puntos de calor GOES NOAA. </li>
                <!--<li>Mapa del acumulado de puntos de calor de una hora que se actualizan cada media hora. Resolución: 1 km. En la pestaña de Temas se encuentra como Puntos de calor GOES (última hora).</li>
                <li>Se muestran los puntos en un heatmap (elaborado por la CONABIO) que indica con colores las áreas con mayor concentración de puntos. En la pestaña de Temas se encuentra como Densidad de puntos de calor.</li>
                <li>Mapa que muestra conjuntos de puntos de calor (elaborado por la CONABIO) indicando la cantidad de puntos detectados. En la pestaña de Temas se encuentra como Clúster de puntos de calor 24 hr.</li> -->
            </ol>
            <p><strong>D.</strong>Clúster de puntos de calor. Mapa que muestra el clúster de puntos de calor de MODIS y VIIRS calculado a partir de la relación espacial y temporal de los puntos de calor detectados.</p>
            <p><strong>E.</strong>Puntos estables. Mapa que muestra los puntos de calor estables identificados a partir del análisis frecuencia y visual. Este mapa se actualiza periódicamente.</p>
            <p><strong>Descarga de datos:</strong></p>
            <p>Los puntos de calor se pueden bajar a través de las opciones ofrecidas en la pestaña de Descargas </p>
            <ol type="a">
                <li>Los puntos de calor del día actual</li>
                <li>Consulta espacial (por unidad administrativa o área natural protegida) y temporal (no hay límite de tiempo), la información disponible se muestra en las 
                    <Link tabLink="#tab-3-7" 
                    on:click={()=>{
                        changeLink('link3_7')
                    }}>tablas 1 y 2</Link> .</li>
                <li>Compuesto mensual de puntos de calor.</li>
            </ol>
            <p>
                La información que se obtiene son las coordenadas (longitud, latitud) con la caracterización del sitio. La cartografía utilizada para asignar las características se puede consultar en la sección <Link tabLink="#tab-6" 
                    on:click={()=>{
                        changeLink('link3_6')
                    }}>cartografía complementaria</Link>, de esta misma página.
            </p>
            <p><strong>Forma de citar:</strong></p>
            <ol type="a">
                <li> Puntos de alor detectados con AVHRR, MODIS y VIIRS</li>
                <p>
                    CONABIO. Comisión Nacional para el Conocimiento y Uso de la Biodiversidad [año]. Puntos de calor detectados con imágenes de satélite. En XXXXX, última consulta [Fecha de consulta].
                    <br/>
                    Los datos digitales disponibles en esta página se distribuyen bajo una licencia Creative Commons Reconocimiento – No comercial 2.5 <Link external href="https://creativecommons.org/licenses/by-nc/2.5/mx/">https://creativecommons.org/licenses/by-nc/2.5/mx/</Link>
                </p>
                <li>Puntos de calor detectados con imágenes ABI-GOES.</li>
                <p>
                    Laboratorio de Observación de la Tierra del Instituto de Geografía de la Universidad Nacional Autónoma de México [año]. Puntos de calor detectados con imágenes de satélite ABI-GOES. En XXX, última consulta [Fecha de consulta]. Incluir la referencia: Manzo-Delgado L.L., Morelli F., Victorino P., Gomez-Rubio C., Mendoza-Castillo U.J. and Aguilar-Sierra A. “Detection of vegetation fires in Mexico using GOES/ABI images: algorithm description and preliminary assessment”. International Journal of Remote Sensing. Enviado el 28 de noviembre 2020. (en revisión). LANOT. Laboratorio de Observación de la Tierra del Instituto de Geografía de la Universidad Nacional Autónoma de México. lanot.unam.mx
                </p>
            </ol>

        </Block>
    </Tab>
    <Tab id="tab-3-2" tabActive={refLink['link3_2']}>
        <BlockTitle >2. MAPAS DE ALERTA</BlockTitle>
        <Block strong mediumInset style="text-align: justify;">
            <p>Para consulta se publican los mapas:</p>
            <ol type="a">
                <li>Mapa que muestra las anomalías de vegetación. Se compararon los datos de NDVI de MODIS de los últimos diez días y los datos históricos de 10 años (análisis harmónico). Resolución: 1km. Se actualiza cada 10 días. Se encuentra en la pestaña de Temas/Alerta.</li>
                <li>Mapa modelo de humedad derivado de GPM y MODIS. Mapa que muestra el contenido de humedad en el combustible de 100 hrs., que se refiere a troncos y ramas gruesos. Resolución: 5 km. Se actualiza diariamente. Se encuentra en pestaña de Temas/Alerta</li>
                <li>Mapa modelo de humedad derivado de GPM y ABI GOES. Mapa que muestra el contenido de humedad en el combustible de 100 hrs., que se refiere a troncos y ramas gruesos. Resolución: 5 km. Se actualiza diariamente. Se encuentra en pestaña de Temas/Alerta</li>
                <li>Mapa de calidad del modelo de humedad derivado de GPM y ABI GOES. Mapa que muestra el día en el que se tomó el dato  de los productos RH y LST (1-6 días o de climatología de 3 años). Resolución: 5 km. Se actualiza diariamente. Se encuentra en pestaña de Temas/Alerta</li>
                <li>Mapa de dinámica de vientos derivados de ABI GOES (DMWVF). Muestra la dirección y velocidad (m/s). Resolución: 2 km Se actualiza diariamente. Se encuentra en pestaña de Temas/Alerta</li>
                <li>Mapa de energía de rayos derivados  de GLM GOES (GLM). Muestra la energía (J) estimada de la actividad por rayos en un rango de Baja, Moderada, Alta . Resolución: 2 km Se actualiza diariamente. Se encuentra en pestaña de Temas/Alerta</li>
                <li>Mapa de Pronóstico de rayos a 60 mins GOES (LightningCast). El modelo LightningCast utiliza imágenes de los canales de luz visible, infrarrojo cercano e infrarrojo de onda larga a bordo del satélite GOES ABI para predecir la probabilidad de que se produzcan rayos en los próximos 60 minutos. Se actualiza diariamente. Se encuentra en pestaña de Temas/Alerta</li>
                <li>Mapa de precipitación derivada de ABI GOES (RRQPEF). Muestra la precipitición de 0 a 100 mm/hr. Resolución: 2 km Se actualiza diariamente. Se encuentra en pestaña de Temas/Alerta</li>
            </ol>
            <p>
                Los datos GOES provienen de: 
                    LANOT (https://www.lanot.unam.mx/) 
                    NOAA AWS (https://noaa-goes16.s3.amazonaws.com/index.html)
            </p>
            <p><strong>Forma de citar:</strong> CONABIO. Comisión Nacional para el Conocimiento y Uso de la Biodiversidad. [año]. Modelo de Humedad del Combustible Muerto de 100 hrs. [año]. En https://incendios.conabio.gob.mx, última consulta [Fecha de consulta].</p>
        </Block>
    </Tab>
    <Tab id="tab-3-3" tabActive={refLink['link3_3']}>
        <BlockTitle>3. ÁREAS QUEMADAS Y EMISIONES</BlockTitle>
        <Block strong mediumInset style="text-align: justify;">
            <p>En la pestaña de Temas se encuentra el mapa mensual del mes inmediato anterior.</p>
            <p>Las áreas quemadas en compuestos mensuales se encuentran disponibles desde enero de 2017 a al mes inmediato anterior de hoy, se pueden bajar a través de la pestaña de Descargas.</p>
            <p><strong>Forma de citar:</strong> CONABIO. Comisión Nacional para el Conocimiento y Uso de la Biodiversidad. [año]. Áreas quemadas identificadas con imágenes MODIS 500 m [año]. En XXXXX, última consulta [Fecha de consulta].</p>
            <p>Frecuencia de áreas quemadas para México.</p>
            <p><strong>Forma de citar:</strong> CONABIO. [año]. Frecuencia de áreas quemadas de 2001 a [año] para México. Comisión Nacional para el Conocimiento y Uso de la Biodiversidad. Ciudad de México, México. En XXXXX, última consulta [Fecha de consulta].</p>
            <p>Frecuencia de áreas quemadas para Centroamérica.</p>
            <p><strong>Forma de citar:</strong> CONABIO. [año]. Frecuencia de áreas quemadas de 2001 a [año] para Centroamérica. Comisión Nacional para el Conocimiento y Uso de la Biodiversidad. Ciudad de México, México. En XXXXX, última consulta [Fecha de consulta].</p>
            <p>Las información de emisiones de gases proviene del producto horario Regional ABI-VIIRS Emissions (RAVE) de la NOAA, se publican los gases:  dióxido de carbono (CO2) , 
                monóxido de carbono (CO), partículas finas (PM2.5), dióxido de azufre (SO2), carbono orgánico (OC), carbono negro (BC), óxidos de nitrógeno (NOx ), amoníaco (NH3 ), 
                metano (CH4) y compuestos orgánicos volátiles (VOC); La capa se actualiza cada hora.</p>
            <p>Para más información del producto RAVE: https://www.ospo.noaa.gov/products/land/rave/ </p>
            <p><strong>Forma de citar:</strong> RAVE. Regional ABI and VIIRS Emissions. [año]. Emisiones estimadas para 10 compuestos químicos. Producto horario [yyyy-mm-dd-hhhh]. En https://incendios.conabio.gob.mx, última consulta [Fecha de consulta].</p>
            <p>El compuesto de 24 horas del producto (RAVE) de la NOAA, se realiza mendiente una suma de las observaciones de gases en el mismo punto; La capa se actualiza cada hora.</p>
            <p><strong>Forma de citar:</strong> RAVE. Regional ABI and VIIRS Emissions. [año]. Emisiones estimadas para 10 compuestos químicos. Acumulado de 24 horas [yyyy-mm-dd-hhhh]. En https://incendios.conabio.gob.mx, última consulta [Fecha de consulta].</p>
            <p>Profundidad óptica de los aerosoloes (AOD). Es una estimación cuantitativa de la cantidad de aerosoles presentes en la atmósfera (automóviles, industria, incendios, tormentas de polvo, etc.), 
                y puede utilizarse como indicador de las partículas en suspensión PM2.5 en la superficie (partículas con un diámetro mediano inferior a 2.5 μm m). Resolución: 2 km. Se actualiza diariamente.</p>
                <p><strong>Forma de citar:</strong> GOES AOD. Profundidad óptica de los aerosoloes de GOES. [año]. Profundidad óptica de los aerosoloes. Última observación [yyyy-mm-dd-hhhh]. En https://incendios.conabio.gob.mx, última consulta [Fecha de consulta].</p>
        </Block>
    </Tab>
    <Tab id="tab-3-4" tabActive={refLink['link3_4']}>
        <BlockTitle>4. MAPAS RESULTADO DE ANÁLISIS</BlockTitle>
        <Block strong mediumInset style="text-align: justify;">
            <p>
                En el sistema se encuentran dos mapas generados con datos históricos, ambos están disponibles en Temas para su consulta: 
            </p>
            <ol type="a">
                <li>Mapa que muestra las anomalías de vegetación. Se compararon los datos de NDVI de MODIS de los últimos diez días y los datos históricos de 10 años (análisis harmónico). Resolución: 1km. Se actualiza cada 10 días. Se encuentra en la pestaña de Temas/Alerta.</li>
                <p><strong>Forma de citar:</strong></p>
                <p> CONABIO. Comisión Nacional para el Conocimiento y Uso de la Biodiversidad. [año]. Frecuencia de áreas quemadas de 2000 a 20[aa] para México.</p>
                <p> CONABIO. Comisión Nacional para el Conocimiento y Uso de la Biodiversidad. [año]. Frecuencia de áreas quemadas de 2000 a 20[aa] para Centroamérica.</p>
                <li>Índice de amenaza a la biodiversidad por incendios forestales.</li>
                <p><strong>Forma de citar:</strong> CONABIO. Comisión Nacional para el Conocimiento y Uso de la Biodiversidad. 2020. índice de Amenaza a la Biodiversidad por Incendios Forestales. CONABIO, México.</p>
                <li>Presión del fuego por Incendios Forestales. Se analizan el periodo de retorno y la frecuencia de los puntos de calor sobre una rejilla de 1 km, se clasifican en 4, se actualiza anualmente.</li>
                <p><strong>Forma de citar:</strong> CONABIO. Comisión Nacional para el Conocimiento y Uso de la Biodiversidad. 2020. Presión del fuego por Incendios Forestales. CONABIO, México.</p>
                <li>Áreas Prioritarias de protección contra incendios forestales. El mapa muestra las áreas priritarias de protección contra incendios forestales y es una herramienta clave para la priorización de las acciones de manejo del fuego en México. La elaboración del mapa se fundamenta en un análisis multicriterio jerarquizado que considera tres componentes esenciales: riesgo, peligro y valor. Resolución: 30 m</li>
                <p><strong>Forma de citar:</strong> Silva-Cardoza, A.I.; Vega-Nieva, D.J.; Briseño Reyes, J.; Tinoco Orozco, D.A.; Monjarás-Vega, N.A.; Briones-Herrera, C.I.; Robles-Gutiérrez, C.A. Esquerra Manjarrez, F.I.; Ricárdez Díaz, Y.U.; Salas Partida, A.V. (2024). Metodología para la actualización del mapa de áreas prioritarias contra incendios forestales 2024. Comisión Nacional Forestal-Universidad Juárez del Estado de Durango, México. 50 pág.</p>
            </ol>
        </Block>
    </Tab>
    <Tab id="tab-3-5" tabActive={refLink['link3_5']}>
        <BlockTitle>5. MOSAICOS DE IMÁGENES SATELITALES MODIS, VIIRS y ABI-GOES</BlockTitle>
        <Block strong mediumInset style="text-align: justify;">
            <p>
                Estos productos sirven de referencia para analizar los puntos de calor en el contexto espacial actual. Se consultan en la pestaña de Temas.
            </p>
            <ol type="a">
                <li>Mosaico MODIS. Mosaico de imágenes del sensor MODIS en falso color (bandas 7,2,1) e imagen en color verdadero (bandas 1,4,3). Se actualizan cada vez que se recibe un nuevo paso de satélite de la misma fecha.</li>
                <li>Mosaico VIIRS. Mosaico de imágenes en falso color (bandas 11,7,5) e imagen en color verdadero (bandas 5,4,3). Se actualizan cada vez que se recibe un nuevo paso de satélite de la misma fecha.</li>
                <li>Mosaico nocturno VIIRS. Mosaico de las bandas día /noche (DNB por sus siglas en inglés) de las imágenes nocturnas del sensor VIIRS. Se actualizan cada vez que se recibe un nuevo paso de satélite de la misma fecha.</li>
                <li>Mosaico GOES. Mosaico de imágenes del sensor ABI en falso color (bandas 2, 3, 5) e imagen en color verdadero (bandas 1, pseudo verde, 2). se actualiza cada 10 mins. </li>
            </ol>
            <p>
                Los datos GOES provienen de:
                    LANOT (https://www.lanot.unam.mx/) 
                    NOAA AWS (https://noaa-goes16.s3.amazonaws.com/index.html)
            </p>

        </Block>
    </Tab>
    <Tab id="tab-3-6" tabActive={refLink['link3_6']}>
        <BlockTitle>6. CARTOGRAFÍA COMPLEMENTARIA</BlockTitle>
        <Block strong mediumInset style="text-align: justify;">
            <p>
                La cartografía complementaria está disponible sólo para su consulta en esta página web, en <Link
                    on:click={()=>{
                        changeLink('link3_7')
                    }}>la tabla 3</Link>, se muestra los temas y sus fuentes.
            </p>
        </Block>
    </Tab>
    <Tab id="tab-3-7" tabActive={refLink['link3_7']}>
        <BlockTitle>TABLAS</BlockTitle>
        <Block strong mediumInset style="text-align: justify;">
            <p><strong>Tabla 1. Información disponible de puntos de calor para México</strong></p>
            <table style="width:auto;">
                <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td colspan="4">TIPO DE IMAGEN SATELITAL</td>
                </tr>
                <tr>
                    <td>AÑO</td>
                    <td>PEIRODO DE OBSERVACIÓN</td>
                    <td>DMSP-OLS</td>
                    <td>AVHRR</td>
                    <td>MODIS</td>
                    <td>VIIRS</td>
                </tr>
                <tr >
                    <td>1998 *</td>
                    <td>&nbsp;</td>
                    <td>2500 m</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td>1999 * </td>
                    <td>Mayo a agosto</td>
                    <td>    </td>
                    <td>1100 m</td>
                    <td>    </td>
                    <td>    </td>
                </tr>
                <tr>
                    <td>2000</td>
                    <td>Enero - agosto</td>
                    <td>    </td>
                    <td>1100 m</td>
                    <td>    </td>
                    <td>    </td>
                </tr>
                <tr>
                    <td>2001</td>
                    <td>Enero - julio (diurnos)<br/>agosto(nocturnos)</td>
                    <td>    </td>
                    <td>1100 m</td>
                    <td>    </td>
                    <td>    </td>
                </tr>
                <tr>
                    <td>2002</td>
                    <td>Enero - Octubre</td>
                    <td>    </td>
                    <td>1100 m</td>
                    <td>    </td>
                    <td>    </td>
                </tr>
                <tr>
                    <td>2003</td>
                    <td>Enero - agosto (diurnos)<br/>noviembre (nocturnos)</td>
                    <td>    </td>
                    <td>1100 m</td>
                    <td>    </td>
                    <td>    </td>
                </tr>
                <tr>
                    <td>2004</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2005</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2006</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2007</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2008</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2009</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2010</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2011</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2012</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2013</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2014</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>750 m</td>
                </tr>
                <tr>
                    <td>2015</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>750 m</td>
                </tr>
                <tr>
                    <td>2016</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>750 m<br/>375 m</td>
                </tr>
                <tr>
                    <td>2017</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>750 m<br/>375 m</td>
                </tr>
                <tr>
                    <td>2018</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>375 m</td>
                </tr>
                <tr>
                    <td>2019</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>375 m</td>
                </tr>
                <tr>
                    <td>2020</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>375 m</td>
                </tr>
                <tr>
                    <td>2021</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>375 m</td>
                </tr>
            </table>
            <p>* No se encuentran en la base de datos, se pueden consultar directo en la página</p>
        </Block>
        <Block strong mediumInset style="text-align: justify;">
            <p><strong>Tabla 2. Información disponible de puntos de calor para México de Centro América</strong></p>
            <table style="width:auto;">
                <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td colspan="4">TIPO DE IMAGEN SATELITAL</td>
                </tr>
                <tr>
                    <td>AÑO</td>
                    <td>PEIRODO DE OBSERVACIÓN</td>
                    <td>AVHRR</td>
                    <td>MODIS</td>
                    <td>VIIRS</td>
                </tr>
                <tr>
                    <td>2003</td>
                    <td>Enero - agosto (diurnos)<br/>noviembre (nocturnos)</td>
                    <td>1104 m</td>
                    <td>    </td>
                    <td>    </td>
                </tr>
                <tr>
                    <td>2004</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2005</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2006</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2007</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2008</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2009</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2010</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2011</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2012</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2013</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td></td>
                </tr>
                <tr>
                    <td>2014</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>750 m</td>
                </tr>
                <tr>
                    <td>2015</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>750 m</td>
                </tr>
                <tr>
                    <td>2016</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>750 m<br/>375 m</td>
                </tr>
                <tr>
                    <td>2017</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>750 m<br/>375 m</td>
                </tr>
                <tr>
                    <td>2018</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>375 m</td>
                </tr>
                <tr>
                    <td>2019</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>375 m</td>
                </tr>
                <tr>
                    <td>2020</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>375 m</td>
                </tr>
                <tr>
                    <td>2021</td>
                    <td>Enero - diciembre</td>
                    <td>    </td>
                    <td>1000 m</td>
                    <td>375 m</td>
                </tr>
            </table>
        </Block>
        <Block strong mediumInset style="text-align: justify;">
            <p><strong>Tabla 3. Cartografía complementaria</strong></p>
            <table style="width:auto;">
                <tr>
                    <td>Tema</td>
                    <td>Fuente</td>
                </tr>
                <tr>
                    <td>Cobertura del suelo</td>
                    <td>
                        Centro Canadiense de Teledetección, Sector Ciencias de la Tierra, ministerio de Recursos Naturales. Earth Sciences Sector, Natural Resources Canada), Comisión Nacional para el Conocimiento y Uso de la Biodiversidad (CONABIO), Comisión Nacional Forestal (Conafor), Instituto Nacional de Estadística y Geografía (Inegi), Servicio Geológico de Estados Unidos (U.S. Geological Survey, USGS), (2016). Cobertura del suelo de México, 2010, a 250 metros. Ottawa, Ontario, Canadá, Centro Canadiense de Teledetección (Canada Centre for Remote Sensing, CCRS); Sioux Falls, Dakota del Sur, Estados Unidos, Servicio Geológico de Estados Unidos (U.S. Geological Survey, USGS); Aguascalientes, Aguascalientes, México, Instituto Nacional de Estadística y Geografía (INEGI); Montreal, Quebec, Canadá, Comisión para la Cooperación Ambiental. Acceso_en_línea: <Link href="http://www.conabio.gob.mx/informacion/gis/" external>http://www.conabio.gob.mx/informacion/gis/</Link>
                    </td>
                </tr>
                <tr>
                    <td>
                        Luces Estables México<br/>
                        Luces Estables para<br/>Centro América
                    </td>
                    <td>
                        Earth Observation Group, NOAA/NCEI. 2016. Nighttime VIIRS Day/Night Band Annual Composites, ver. 1. En
                        <Link href="https://eogdata.mines.edu/download_dnb_composites.html" external >https://eogdata.mines.edu/download_dnb_composites.html</Link>, última consulta: 25 de septiembre de 2020.
                    </td>
                </tr>
                <tr>
                    <td>Áreas Naturales Protegidas</td>
                    <td>Comisión Nacional de Áreas Naturales Protegidas 2019. Cobertura de las Áreas Naturales Protegidas Federales de México. México. Comisión Nacional de Áreas Naturales Protegidas.</td>
                </tr>
                <tr>
                    <td>Centros Regionales de Manejo del Fuego</td>
                    <td>CONAFOR</td>
                </tr>
                <tr>
                    <td>Área Prioritarias de Protección contra Incendios Forestales</td>
                    <td>CONAFOR</td>
                </tr>
            </table>
        </Block>
    </Tab>
</Tabs>